import { lazy } from "react";

// Defers the TipTap editor (~840KB with prosemirror) into an async chunk —
// it's client-only, so the server renders the fallback and the editor loads
// after hydration.
//
// The Suspense boundary lives in NewsDrawer rather than here: every item shares
// this one chunk, so a per-item boundary just produced one fallback per doc.
// A single boundary around the list lets the drawer show a fixed-size skeleton.
const NewsDrawerItem = lazy(() => import("./NewsDrawerItem.impl"));

export default NewsDrawerItem;
